
// function fun_sizeguide(){
//   let checkbox = document.getElementById("sizeguide");
//    if ( checkbox.checked ) {
//       document.getElementsByClassName('label_centimeter')[0].style.color = "#808080";
//       document.getElementsByClassName('label_inches')[0].style.color = "#000000";
//       document.getElementById('centi_wrap').style.display ='none';
//       document.getElementById('inches_wrap').style.display ='block';
//    } else {
//        document.getElementsByClassName('label_centimeter')[0].style.color = "#000000";
//         document.getElementsByClassName('label_inches')[0].style.color = "#808080";
//         document.getElementById('centi_wrap').style.display ='block';
//         document.getElementById('inches_wrap').style.display ='none';
//    }  
// }

function fun_sizeguide(event) {
     var checkbox = event;
  var current_id = checkbox.getAttribute('id');
  var parent_block = $('#'+current_id).parent().parent().parent().parent().parent().parent().parent().parent().parent();
    // Toggle visibility for both sets of divs
    if (checkbox.checked) {
      // Show both 'inches_wrap', Hide both 'centi_wrap'
      let inchesDivs = document.querySelectorAll('#inches_wrap');
      let centiDivs = document.querySelectorAll('#centi_wrap');
      
      inchesDivs.forEach(div => {
        div.style.display = 'block';  // Show the 'inches_wrap'
      });
      
      centiDivs.forEach(div => {
        div.style.display = 'none';  // Hide the 'centi_wrap'
      });
    } else {
      // Show both 'centi_wrap', Hide both 'inches_wrap'
      let inchesDivs = document.querySelectorAll('#inches_wrap');
      let centiDivs = document.querySelectorAll('#centi_wrap');
      
      inchesDivs.forEach(div => {
        div.style.display = 'none';  // Hide the 'inches_wrap'
      });
      
      centiDivs.forEach(div => {
        div.style.display = 'block';  // Show the 'centi_wrap'
      });
    }
}

// $(document).ready(function(){
//   setTimeout(function() {
//     $('#insta-feed h2').append('<div class="insta-icon"><i class="fa fa-instagram" style="font-size:30px;padding-top: 3px;"></i></div>');
//   }, 2500);
// }); 

$(document).ready(function(){
 $('.youtube-video-container').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    centerMode: false,
    // centerPadding: '30px',
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
    breakpoint: 900,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 570,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
  });
});